// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".participants-length {\n  margin-right: 20px;\n}\n\n.item__container {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  align-items: center;\n  justify-content: center;\n}\n\n.item-cursor {\n  cursor: pointer;\n}\n\n.ion-item-style {\n  margin-top: 3px;\n  --min-height: 70px;\n  --background: none;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
